import { gql } from '@apollo/client';
export const getUsersForAssignationQuery = gql `
  query userssers($organizationID: ID!, $permissions: [String!]) {
    users(organizationID: $organizationID, permissions: $permissions) {
      id
      name
    }
  }
`;
